export default __webpack_public_path__ + "static/media/react.37b2d287.svg";